export default "__VITE_ASSET__BIm734or__"